import { Event } from '@/types/events';

const baseEvents: Event[] = [
  {
    id: '1',
    title: 'Student Success Workshop',
    description: 'Interactive workshop focusing on study skills and time management',
    startDate: '2024-01-15T09:00:00Z',
    endDate: '2024-01-15T12:00:00Z',
    tierClassification: 'universal',
    locationType: 'physical',
    location: 'Main Auditorium',
    virtualLink: '',
    eventCategory: 'workshop',
    objectives: ['Minimum attendance percentage'],
    targetGrades: [],
    eventResources: [],
    staffAssignments: [],
    frequencyType: 'multiple_times',
    occurrences: [],
    budget: [],
    tasks: [],
    feedback: [],
    compliance: [],
    metrics: {
      attendance: 0,
      satisfaction: 0,
      budget: {
        estimated: 100,
        actual: 100,
        variance: 100,
      },
    },
    // targetAudience: {
    //   grades: [9, 10],
    //   groups: ['at-risk-students']
    // },
    resources: [],
    // staff: [
    //   {
    //     id: 'staff1',
    //     name: 'Jane Smith',
    //     role: 'Workshop Leader'
    //   }
    // ],
    status: 'pending_approval',
    // progress: 50,
    createdAt: '2024-01-01T00:00:00Z',
    // updatedAt: '2024-01-01T00:00:00Z'
  },
  {
    id: '2',
    title: 'Parent-Teacher Conference',
    description: 'Virtual meeting to discuss student progress',
    startDate: '2024-01-20T14:00:00Z',
    endDate: '2024-01-20T17:00:00Z',
    tierClassification: 'universal',
    locationType: 'virtual',
    location: 'zoom',
   virtualLink: '',
    eventCategory: 'workshop',
    objectives: ['Minimum attendance percentage'],
    targetGrades: [],
    eventResources: [],
    staffAssignments: [],
    frequencyType: 'multiple_times',
    occurrences: [],
    budget: [],
    tasks: [],
    feedback: [],
    compliance: [],
    metrics: {
      attendance: 0,
      satisfaction: 0,
      budget: {
        estimated: 100,
        actual: 100,
        variance: 100,
      },
    },
    // targetAudience: {
    //   grades: [9, 10],
    //   groups: ['at-risk-students']
    // },
    resources: [],
    status: 'pending_approval',
    // progress: 25,
    createdAt: '2024-01-02T00:00:00Z',
    // updatedAt: '2024-01-02T00:00:00Z'
  }
];

const additionalEvents: Event[] = [
  {
  id: '4',
  title: 'Student Success Workshop4',
  description: 'Interactive workshop focusing on study skills and time management',
  startDate: '2024-01-15T09:00:00Z',
  endDate: '2024-01-15T12:00:00Z',
  tierClassification: 'universal',
  locationType: 'physical',
  location: 'Main Auditorium',
  virtualLink: '',
  eventCategory: 'workshop',
  objectives: ['Minimum attendance percentage'],
  targetGrades: [],
  eventResources: [],
  staffAssignments: [],
  frequencyType: 'multiple_times',
  occurrences: [],
  budget: [],
  tasks: [],
  feedback: [],
  compliance: [],
  metrics: {
    attendance: 0,
    satisfaction: 0,
    budget: {
      estimated: 100,
      actual: 100,
      variance: 100,
    },
  },
  // targetAudience: {
  //   grades: [9, 10],
  //   groups: ['at-risk-students']
  // },
  resources: [],
  // staff: [
  //   {
  //     id: 'staff1',
  //     name: 'Jane Smith',
  //     role: 'Workshop Leader'
  //   }
  // ],
  status: 'pending_approval',
  // progress: 50,
  createdAt: '2024-01-01T00:00:00Z',
  // updatedAt: '2024-01-01T00:00:00Z'
},
{
  id: '3',
  title: 'Parent-Teacher Conference3',
  description: 'Virtual meeting to discuss student progress',
  startDate: '2024-01-20T14:00:00Z',
  endDate: '2024-01-20T17:00:00Z',
  tierClassification: 'universal',
  locationType: 'virtual',
  location: 'zoom',
 virtualLink: '',
  eventCategory: 'workshop',
  objectives: ['Minimum attendance percentage'],
  targetGrades: [],
  eventResources: [],
  staffAssignments: [],
  frequencyType: 'multiple_times',
  occurrences: [],
  budget: [],
  tasks: [],
  feedback: [],
  compliance: [],
  metrics: {
    attendance: 0,
    satisfaction: 0,
    budget: {
      estimated: 100,
      actual: 100,
      variance: 100,
    },
  },
  // targetAudience: {
  //   grades: [9, 10],
  //   groups: ['at-risk-students']
  // },
  resources: [],
  status: 'pending_approval',
  // progress: 25,
  createdAt: '2024-01-02T00:00:00Z',
  // updatedAt: '2024-01-02T00:00:00Z'
}];

// Export combined mock events
export const mockEvents: Event[] = [...baseEvents, ...additionalEvents];